import relatorioProducao from './relatorioProducao'
import parametrizacao from './parametrizacao'
import jornada from './jornada'
import agendamento from './agendamento'
import fechamento from './fechamento'
import lancamento from './lancamento'
import impressoes from './impressoes'
import alteracaoExameFinalizado from './alteracaoExameFinalizado'
import reimpressaoResultado from './reimpressaoResultado'
import relatorioExameStatus from './relatorioExameStatus'
import alteracaoResultadoLancamento from './alteracaoResultadoLancamento'
import listagemExameAgendado from './listagemExameAgendado'
import exameAgendadoRealizado from './exameAgendadoRealizado'
import agendamentoRetroativo from './agendamentoRetroativo'
import relatorioCotaProfissional from './relatorioCotaProfissional'
import relatorioFinanceiroExame from './relatorioFinanceiroExame'

export default [
    {
        path: 'exame-imagem',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...relatorioProducao,
            ...parametrizacao,
            ...jornada,
            ...agendamento,
            ...fechamento,
            ...lancamento,
            ...impressoes,
            ...alteracaoExameFinalizado,
            ...reimpressaoResultado,
            ...relatorioExameStatus,
            ...alteracaoResultadoLancamento,
            ...listagemExameAgendado,
            ...exameAgendadoRealizado,
            ...agendamentoRetroativo,
            ...relatorioCotaProfissional,
            ...relatorioFinanceiroExame
        ]
    }
]